import { useEffect } from "react"
import { useShallow } from "zustand/react/shallow"
import { useBlockchainMonitoringStore } from "../stores/blockchainMonitoringStore"

export const useBlockchainMonitoring = () => {
  const { monitoringStatus, isLoading, error } = useBlockchainMonitoringStore(
    useShallow((state) => ({
      monitoringStatus: state.monitoringStatus,
      isLoading: state.isLoading,
      error: state.error,
    })),
  )

  const fetchMonitoringStatus = useBlockchainMonitoringStore((state) => state.fetchMonitoringStatus)
  const reset = useBlockchainMonitoringStore((state) => state.reset)

  useEffect(() => {
    if (!monitoringStatus && !isLoading && !error) {
      useBlockchainMonitoringStore.getState().fetchMonitoringStatus()
    }
  }, [monitoringStatus, isLoading, error])

  return {
    monitoringStatus,
    isLoading,
    error,
    fetchMonitoringStatus,
    reset,
  }
}
